import DefaultCard from './DefaultCard';

export default DefaultCard;
